<template>
    <div v-if="authenticated">
        <v-layout align-center row justify-start>
        <div class="dLabel">{{ complabel }}</div>
        <div>
            <v-icon class="dArrow">trending_flat</v-icon>
        </div>
        <div>
            <v-menu offset-y>
            <v-btn v-if="this.altloclabel == true" class="dSelect" small round light slot="activator">{{ btnlabel }}</v-btn>
            <v-btn v-else class="dSelect" small round light slot="activator">{{ this.selectedLocation.name }}</v-btn>
            <v-list>
                <v-list-tile v-bind:key="value.name" v-for="value in locations" @click="doSelectedLocation(value)">
                <v-list-tile-title>{{ value.name }} - {{ value.description }}</v-list-tile-title>
                </v-list-tile>
            </v-list>
            </v-menu>
        </div>
        </v-layout>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations, mapGetters } from 'vuex'

  export default {
      data() {
        return {
            locations: [],
            showLocList: false,
            altloclabel: false
        }
    },
    props: {
        complabel: {
                type: String,
                default () {
                return ''
            }
        },
        btnlabel: {
                type: String,
                default () {
                return ''
            }
        }
    },
    methods: {
          ...mapMutations([
            'setSelectedLocation'
        ]),
        ...mapGetters([
            'getLoggedInUser',
            'getAccountHeader',
            'getUserHeader',
            'getAuthToken'
        ]),
        doSelectedLocation( _value ) {
            this.setSelectedLocation( _value );
            this.setAltLocationFlag();
        },
        getLocations() {
            var url         = this.secureHost + "/thermocouple-services/tc/locations/" + this.getLoggedInUser().accountId,
                acctHeader  = this.getAccountHeader(),
                userHeader  = this.getUserHeader(),
                acctId      = this.getLoggedInUser().accountId,
                userId      = this.getLoggedInUser().id;
            axios({ method: "GET", "url": url, "headers": { "Accept": "application/json", acctHeader: acctId, userHeader: userId, "Authorization": this.getAuthToken() } }).then(result => {
                    this.locations = result.data.locations;
                    if (  this.locations.length == 1 ) {
                        this.setSelectedLocation( this.locations[0] );
                        this.setAltLocationFlag();
                        this.showLocList = false;
                    }
                    else {
                        if ( this.altloclabel === true ) {
                            this.kilns.unshift( {name:'Select', description:'All locations'} );
                        }
                        this.showLocList = true;
                    }
                }).catch(error => {
                    this.text = 'Error retrieving location list'
                    this.snackbar = true;
                });
        },
        setAltLocationFlag() {
            if ( (this.btnlabel != '') && (this.selectedLocation.name === 'Select') ) {
                this.altloclabel = true;
            } else {
                this.altloclabel = false;
            }
        }
      },
      computed: {
        ...mapState([
            'selectedLocation',
            'authenticated',
            'secureHost'
        ])
    },
    mounted() {
            this.getLocations();
            this.setAltLocationFlag();
    }
  }
</script>

<style scoped>
.dLabel {
    min-width: 75px
}
.dSelect {
    min-width: 100px
}
.dArrow {
    min-width: 20px;
    font-size: 16px
}
</style>
